import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';

import AdviceSection from '../common/AdviceSection';
import SectionCard from '../common/cards/SectionCard';

const WorkingConditions = props => {

	useEffect(() => {
		// Update the title of the page
		document.title = props.literals.L22013 +  " - " + props.literals.L22020 + " - " + props.literals.L363;
	}, [])

	return(
		<div className="working-conditions">
			<AdviceSection literals={props.literals} section={["working-conditions-preventions","working-conditions"]} methodologyData={{section: 'working-conditions-preventions', subsection: 'Working conditions', indicator: 65}} />

			<section className="container-fluid background-gray section--page">
				<div className="container">
					<h2 className="title-section second-color">{props.literals.L20708}</h2>
					<section className="card--grid xxs-w1 w3 center-text flex-center">
						<SectionCard
							iconClass = "overall-opinion-icon"
							link = "/working-conditions-preventions/overall-opinion/job-satisfaction/"
							title = { props.literals.L20709 }
							text = { props.literals.L20577 }
							seeMore = { props.literals.L480 }
						/>
						<SectionCard
							iconClass = "mental-risk-icon"
							link = "/working-conditions-preventions/mental-risk/risk-factors/time-pressure/osh-pulse"
							title = { props.literals.L20710 }
							text = { props.literals.L20578 }
							seeMore = { props.literals.L480 }
						/>
						<SectionCard
							iconClass = "physical-risk-icon"
							link = "/working-conditions-preventions/physical-risk/vibrations-loud-noise-and-temperature"
							title = { props.literals.L20711 }
							text = { props.literals.L20579 }
							seeMore = { props.literals.L480 }
						/>
						<SectionCard
							iconClass = "safety-risk-icon"
							link = "/working-conditions-preventions/safety-risks/fatal-accidents/operating-machine"
							title = { props.literals.L20062 }
							text = { props.literals.L20061 }
							seeMore = { props.literals.L480 }
						/>
						<SectionCard
							iconClass = "digitalisation-risk-icon"
							link = "/working-conditions-preventions/digitalisation-risks/effects-digitalisation/pace-work"
							title = { props.literals.L20833 }
							text = { props.literals.L20834 }
							seeMore = { props.literals.L480 }
						/>
					</section>
				</div>
			</section>
		</div>
	)
}
WorkingConditions.displayName = 'WorkingConditions';
export default WorkingConditions;